import { render, staticRenderFns } from "./ShareRewards.vue?vue&type=template&id=6016a672&scoped=true"
import script from "./ShareRewards.vue?vue&type=script&lang=js"
export * from "./ShareRewards.vue?vue&type=script&lang=js"
import style0 from "./ShareRewards.vue?vue&type=style&index=0&id=6016a672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6016a672",
  null
  
)

export default component.exports